import { n as normalizeComponent } from './normalize-component-cf2db48b.js';
import { c as createInjector } from './browser-ac904bdc.js';

const MdIcon = {
  name: "md-icon",
  props: {
    mdSrc: String,
    iconSvg: String,
    badge: Number,
    iconColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: String,
      default: "24px"
    }
  },
  data: () => ({
    svgContent: null,
    imageSrc: null
  }),
  computed: {
    badgeText() {
      return Math.min(this.badge, 99);
    },
    currentTheme() {
      return this.theme;
    },
    cssVariables() {
      return {
        "--size": this.size,
        "--icon-color": this.iconColor
      };
    }
  }
};

const __vue_script__ = MdIcon;
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('span', {
    staticClass: "md-icon",
    style: _vm.cssVariables
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    class: _vm.currentTheme,
    attrs: {
      "d": _vm.iconSvg
    }
  })]), _vm._v(" "), _vm.badge ? _c('span', {
    staticClass: "md-icon__badge"
  }, [_vm._v(_vm._s(_vm.badgeText))]) : _vm._e()]);
};
var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-42bef4d4_0", {
    source: ".md-icon{width:var(--size);min-width:var(--size);height:var(--size);min-height:var(--size);position:relative;margin:auto;display:inline-flex!important;align-items:center;text-rendering:optimizeLegibility;vertical-align:middle;fill:var(--icon-color)}.md-icon svg{width:var(--size);height:auto}.md-icon__badge{background-color:#ef5350;color:rgba(255,255,255,.9);position:absolute;top:-6px;right:-6px;width:12px;height:12px;border-radius:50%;text-align:center;font-size:7px;font-style:normal;line-height:12px;font-family:Mulish,Helvetica,Arial,-apple-system,BlinkMacSystemFont,sans-serif}img.md-icon{user-select:none;-webkit-user-drag:none}",
    map: undefined,
    media: undefined
  });
};
const __vue_scope_id__ = undefined;
const __vue_module_identifier__ = undefined;
const __vue_is_functional_template__ = false;
const __vue_component__ = normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

export { __vue_component__ as default };
